module.exports = __webpack_public_path__ + "static/media/file.6c65ccbb.svg";